import { ClientTokenAuthentication, FliptClient } from '@flipt-io/flipt'

import config from 'config'

export const FLIPT_API_CLIENT = new FliptClient({
  url: config.NEXT_PUBLIC_FLIPT_URL || 'https://flipt-v2.yellowdig.app',
  authenticationStrategy: new ClientTokenAuthentication(
    config.NEXT_PUBLIC_FLIPT_TOKEN
  )
})
